/**
 * 圃場セットのフィルタ評価 (v1 はクライアント側)。
 * フィルタの本筋は圃場の有効期間 (field_attrs) を元にした時系列 + 作目 + 名称/メモ。
 */

/** フォーム値 {validFrom, validTo, crop, namePattern, memoPattern, excluded} から宣言的フィルタを作る */
export function buildFieldSetFilter(form) {
  // 有効期間は from/to で保持する (旧形式 {at: 対象日} のセットも evaluate 側で互換)
  const period = form.validFrom || form.validTo ? { from: form.validFrom || null, to: form.validTo || null } : null
  return {
    period,
    crop: form.crop || null,
    name_pattern: form.namePattern || null,
    memo_pattern: form.memoPattern || null,
    exclude_field_ids: form.excluded || [],
  }
}

/**
 * フィルタに合う圃場を返す。
 * @param {Array} fields ストアの圃場一覧
 * @param {Object} attrs field_attrs (pk文字列 → {valid_from, valid_to, crop})
 * @param {Object} filter 宣言的フィルタ
 * @param {Object} [options] ignoreExcluded: true で除外リストを無視 (プレビュー用)
 */
export function evaluateFieldSetFilter(fields, attrs, filter, options) {
  const f = filter || {}
  const excluded = (f.exclude_field_ids || []).map(String)
  const at = f.period && f.period.at
  const from = f.period && f.period.from
  const to = f.period && f.period.to
  return (fields || []).filter(field => {
    const a = (attrs || {})[String(field.pk)] || {}
    if (at) {
      // 旧形式: 対象日時点で有効な圃場
      if (a.valid_from && a.valid_from > at) return false
      if (a.valid_to && a.valid_to < at) return false
    }
    if (from || to) {
      // 有効期間 (from〜to) と圃場の有効期間が重なる圃場
      if (from && a.valid_to && a.valid_to < from) return false
      if (to && a.valid_from && a.valid_from > to) return false
    }
    if (f.crop && (a.crop || '') !== f.crop) return false
    if (f.name_pattern && !(field.name || '').includes(f.name_pattern)) return false
    if (f.memo_pattern && !(field.caption || '').includes(f.memo_pattern)) return false
    if (!(options && options.ignoreExcluded) && excluded.includes(String(field.pk))) return false
    return true
  })
}

/** 圃場からポリゴンを抽出してメンバー形式 {field_id, field_name, polygon} にする */
export function resolveFieldPolygons(fields) {
  return (fields || [])
    .map(f => {
      let polygon = null
      try {
        const g = JSON.parse(f.geoJson)
        const feature = g.features && g.features[0]
        if (feature && feature.geometry && feature.geometry.type === 'Polygon') {
          polygon = feature.geometry
        }
      } catch (e) {
        console.error(e)
      }
      return polygon ? { field_id: String(f.pk), field_name: f.name, polygon } : null
    })
    .filter(Boolean)
}
